import React from "react";
import IDHFormattedMessage from "src/app/components/IDHFormattedMessage/IDHFormattedMessage";
import { ReactComponent as OverlapIcon } from "src/images/audience-overlap.svg";
import { Doughnut } from "../../../components/Doughnut/Doughnut";
import DottedBox from "../../../components/DottedBox/DottedBox";
import METHODS from "../../../helpers/methods";

export const OverlapDataChart = (props) => {
  const { chartData, overlapData } = props;

  return (
    <div className="audience-overlap-pane__row">
      <div className="audience-overlap-pane__column audience-overlap-pane__column--boxes">
        {overlapData && overlapData?.reportInfo && (
          <>
            <DottedBox className="audience-overlap-pane__box">
              <div className="audience-overlap-pane__row">
                <div className="audience-overlap-pane__box-icon">
                  <OverlapIcon
                    height={24}
                    width={24}
                    className="audience-overlap-pane__box-icon__overlapping"
                  />
                </div>
                <div className="audience-overlap-pane__box-content">
                  <div className="audience-overlap-pane__box-title">
                    <IDHFormattedMessage
                      id="front_audience_overlap_total_overlapping_followers"
                      defaultMessage="Total overlapping Followers"
                    />
                  </div>
                  <div className="audience-overlap-pane__box-amount">
                    <div className="audience-overlap-pane__box-amount__number audience-overlap-pane__box-amount__number">
                      {METHODS.splitNumbers(chartData[0].amount)}
                    </div>
                    <div className="audience-overlap-pane__box-amount__percent audience-overlap-pane__box-amount__percent--overlapping">
                      {METHODS.splitPercents(chartData[0].percent, " ", 1)}
                    </div>
                  </div>
                </div>
              </div>
            </DottedBox>
            <DottedBox className="audience-overlap-pane__box">
              <div className="audience-overlap-pane__row">
                <div className="audience-overlap-pane__box-icon">
                  <OverlapIcon
                    height={24}
                    width={24}
                    className="audience-overlap-pane__box-icon__unique"
                  />
                </div>
                <div className="audience-overlap-pane__box-content">
                  <div className="audience-overlap-pane__box-title">
                    <IDHFormattedMessage
                      id="front_audience_overlap_total_unique_followers"
                      defaultMessage="Total unique Followers"
                    />
                  </div>
                  <div className="audience-overlap-pane__box-amount">
                    <div className="audience-overlap-pane__box-amount__number">
                      {METHODS.splitNumbers(chartData[1].amount)}
                    </div>
                    <div className="audience-overlap-pane__box-amount__percent audience-overlap-pane__box-amount__percent--unique">
                      {METHODS.splitPercents(chartData[1].percent, " ", 1)}
                    </div>
                  </div>
                </div>
              </div>
            </DottedBox>
          </>
        )}
      </div>
      <div className="audience-overlap-pane__column audience-overlap-pane__column--chart">
        {overlapData && overlapData?.reportInfo && (
          <Doughnut
            data={chartData}
            width={252}
            height={252}
            dataKey="amount"
            size={90}
            colors={["#1267FB", "#5EC7EB"]}
          />
        )}
      </div>
    </div>
  );
};
